let ModelService = {
    sortByKey: function(array, key) {
        if (array && key) {
            return array.sort(function(a, b) {
                let x = a && a[key] ? a[key] : null;
                let y = b && b[key] ? b[key] : null;
                return x < y ? -1 : x > y ? 1 : 0;
            });
        } else {
            return array;
        }
    },
    filterMarkets: function(events, markets) {
        if (events && markets && markets.length) {
            events = events.map((ev) => {
                return {
                    ...ev,
                    marketList: ev.marketList.filter(
                        (market) => markets.indexOf(market.marketType) === -1
                    ),
                };
            });
        }
        return events;
    },
    getSportTree: function(
        competitions,
        events,
        type,
        limit,
        limitInSport,
        orderBy,
        removeMarkets
    ) {
        let sportTree = {};

        let counter = 0;
        let sportCounter = {};
        function setup(eventValue) {
            competitions.map((sportValue) => {
                if (
                    sportValue &&
                    eventValue &&
                    sportValue.id === eventValue.sportId
                ) {
                    sportCounter[sportValue.id] =
                        sportCounter[sportValue.id] !== undefined
                            ? sportCounter[sportValue.id]
                            : 0;
                    sportValue.itemList.map((groupValue) => {
                        if (groupValue.id === eventValue.groupId) {
                            let setEventIds = [];
                            groupValue.itemList.map((tournamentValue) => {
                                if (
                                    (!limit || counter < limit) &&
                                    (!limitInSport ||
                                        sportCounter[sportValue.id] <
                                            limitInSport)
                                ) {
                                    if (
                                        sportValue.id === eventValue.sportId &&
                                        groupValue.id === eventValue.groupId &&
                                        tournamentValue.id ===
                                            eventValue.competitionId
                                    ) {
                                        if (!sportTree[sportValue.id]) {
                                            sportTree[sportValue.id] = {
                                                id: sportValue.id,
                                                priority: sportValue.priority,
                                                name: sportValue.name,
                                                groups: {},
                                            };
                                        }

                                        if (
                                            !sportTree[sportValue.id].groups[
                                                groupValue.id
                                            ]
                                        ) {
                                            sportTree[sportValue.id].groups[
                                                groupValue.id
                                            ] = {
                                                id: groupValue.id,
                                                priority: groupValue.priority,
                                                name: groupValue.name,
                                                tournaments: {},
                                            };
                                        }

                                        if (
                                            !sportTree[sportValue.id].groups[
                                                groupValue.id
                                            ].tournaments[tournamentValue.id]
                                        ) {
                                            let eventsType =
                                                type === 'object' ? {} : [];
                                            sportTree[sportValue.id].groups[
                                                groupValue.id
                                            ].tournaments[
                                                tournamentValue.id
                                            ] = {
                                                id: tournamentValue.id,
                                                priority:
                                                    tournamentValue.priority,
                                                name: tournamentValue.name,
                                                events: eventsType,
                                            };
                                        }
                                        if (type === 'object') {
                                            sportTree[sportValue.id].groups[
                                                groupValue.id
                                            ].tournaments[
                                                tournamentValue.id
                                            ].events[eventValue.eventId] = {
                                                type:
                                                    eventValue.marketList &&
                                                    eventValue.marketList[0] &&
                                                    eventValue.marketList[0]
                                                        .marketType
                                                        ? eventValue
                                                              .marketList[0]
                                                              .marketType
                                                        : 0,
                                                event: eventValue,
                                            };
                                        } else {
                                            if (
                                                setEventIds.indexOf(
                                                    eventValue.eventId
                                                ) === -1
                                            ) {
                                                setEventIds.push(
                                                    eventValue.eventId
                                                );
                                                sportTree[sportValue.id].groups[
                                                    groupValue.id
                                                ].tournaments[
                                                    tournamentValue.id
                                                ].events.push(eventValue);
                                            }
                                        }

                                        sportCounter[sportValue.id] =
                                            1 + sportCounter[sportValue.id];
                                        counter++;
                                    }
                                }
                                return tournamentValue;
                            });
                        }
                        return groupValue;
                    });
                }
                return sportValue;
            });
        }

        if (Array.isArray(events)) {
            if (orderBy) {
                events = ModelService.sortByKey(events, orderBy);
            }
            if (removeMarkets && removeMarkets.length) {
                events = ModelService.filterMarkets(events, removeMarkets);
            }
            events.map((eventValue) => {
                setup(eventValue);
                return eventValue;
            });
        } else {
            Object.keys(events).map((key) => setup(events[key]));
        }
        return sportTree;
    },
    getSportTreeWithGroupedByCompetitions: function(
        competitions,
        events,
        type,
        limit,
        limitInSport,
        orderBy
    ) {
        let sportTree = {};

        let counter = 0;
        let sportCounter = {};

        function setup(eventValue) {
            competitions.map((sportValue) => {
                if (
                    sportValue &&
                    eventValue &&
                    sportValue.id === eventValue.sportId
                ) {
                    sportCounter[sportValue.id] =
                        sportCounter[sportValue.id] !== undefined
                            ? sportCounter[sportValue.id]
                            : 0;
                    sportValue.itemList.map((groupValue) => {
                        if (groupValue.id === eventValue.groupId) {
                            let setEventIds = [];
                            groupValue.itemList.map((tournamentValue) => {
                                if (
                                    (!limit || counter < limit) &&
                                    (!limitInSport ||
                                        sportCounter[sportValue.id] <
                                            limitInSport)
                                ) {
                                    if (
                                        sportValue.id === eventValue.sportId &&
                                        groupValue.id === eventValue.groupId &&
                                        tournamentValue.id ===
                                            eventValue.competitionId
                                    ) {
                                        if (!sportTree[sportValue.id]) {
                                            sportTree[sportValue.id] = {
                                                id: sportValue.id,
                                                priority: sportValue.priority,
                                                name: sportValue.name,
                                                groups: {},
                                            };
                                        }

                                        if (
                                            !sportTree[sportValue.id].groups[
                                                tournamentValue.id
                                            ]
                                        ) {
                                            sportTree[sportValue.id].groups[
                                                tournamentValue.id
                                            ] = {
                                                id: groupValue.id,
                                                priority:
                                                    events.indexOf(eventValue) +
                                                    1,
                                                name: groupValue.name,
                                                tournaments: {},
                                            };
                                        }

                                        if (
                                            !sportTree[sportValue.id].groups[
                                                tournamentValue.id
                                            ].tournaments[tournamentValue.id]
                                        ) {
                                            var eventsType =
                                                type === 'object' ? {} : [];
                                            sportTree[sportValue.id].groups[
                                                tournamentValue.id
                                            ].tournaments[
                                                tournamentValue.id
                                            ] = {
                                                id: tournamentValue.id,
                                                priority:
                                                    tournamentValue.priority,
                                                name: tournamentValue.name,
                                                events: eventsType,
                                            };
                                        }

                                        if (type === 'object') {
                                            sportTree[sportValue.id].groups[
                                                tournamentValue.id
                                            ].tournaments[
                                                tournamentValue.id
                                            ].events[eventValue.eventId] = {
                                                type:
                                                    eventValue.marketList &&
                                                    eventValue.marketList[0] &&
                                                    eventValue.marketList[0]
                                                        .marketType
                                                        ? eventValue
                                                              .marketList[0]
                                                              .marketType
                                                        : 0,
                                                event: eventValue,
                                            };
                                        } else {
                                            if (
                                                setEventIds.indexOf(
                                                    eventValue.eventId
                                                ) === -1
                                            ) {
                                                setEventIds.push(
                                                    eventValue.eventId
                                                );
                                                sportTree[sportValue.id].groups[
                                                    tournamentValue.id
                                                ].tournaments[
                                                    tournamentValue.id
                                                ].events.push(eventValue);
                                            }
                                        }

                                        sportCounter[sportValue.id] =
                                            1 + sportCounter[sportValue.id];
                                        counter++;
                                    }
                                }

                                return tournamentValue;
                            });
                        }

                        return groupValue;
                    });
                }

                return sportValue;
            });
        }

        if (Array.isArray(events)) {
            if (orderBy) {
                events = ModelService.sortByKey(events, orderBy);
            }

            events.map((eventValue) => {
                setup(eventValue);

                return eventValue;
            });
        } else {
            Object.keys(events).map((key) => setup(events[key]));
        }

        return sportTree;
    },
    getVaixModelBySportId: function(events) {
        let sortedTypeOfSports = [];
        let groupedEvents = {};

        events.map((event) => {
            if (!sortedTypeOfSports.includes(event.competitionId)) {
                sortedTypeOfSports.push(event.competitionId);
            }
        });

        sortedTypeOfSports.map((item) => {
            groupedEvents[item] = events.filter(
                (event) => event.competitionId === item
            );
        });

        return {
            sortedTypeOfSports,
            groupedEvents,
        };
    },
};

export { ModelService };
